import { render, staticRenderFns } from "./DocumentStep.vue?vue&type=template&id=75bde22f&"
import script from "./DocumentStep.vue?vue&type=script&lang=js&"
export * from "./DocumentStep.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStep.vue?vue&type=style&index=0&id=75bde22f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports